import type { UnderlyingHistorics } from 'components/shared/UnderlyingHistos/UnderlyingHistoModels';

export interface IUnderlyingHistoModalState {
  isFetching: boolean;
  isFetchingFailed: boolean;
  underlyingsHistorics: UnderlyingHistorics;
  errorMessage?: string;
}

export type UnderlyingHistoModalState = Readonly<IUnderlyingHistoModalState>;

export const initialUnderlyingHistoModalState: IUnderlyingHistoModalState = {
  isFetching: false,
  isFetchingFailed: false,
  underlyingsHistorics: { histos: [] },
  errorMessage: undefined,
};
